import React, { useEffect, useRef } from 'react';
import { useGameImageFallback } from '@theme/js/hooks/swiss/useGameImageFallback';
import { addParamsToUrl, getLocationParams } from 'js/utils/url.util';
import style from 'js/components/common/Image/Image.scss';
import { useIsMounted } from 'js/hooks/useIsMounted';

const checkImageUrl = (url) => url && url !== location.href;

export const GameImage = ({
    className = '',
    draggable = false,
    isMobileSpecialCategory,
    images,
    isLoggedIn,
    setLoadGameImage,
    portletType,
    alt,
    isDesktop,
    gameCode = '',
    ...props
}) => {
    const isMounted = useIsMounted();
    const ImgSrc = !isLoggedIn && images.guest || images.base;
    const longURL = addParamsToUrl(getLocationParams(), images.longImg);
    const imageLandscape = addParamsToUrl(getLocationParams(), ImgSrc);

    const {
        landscapeImageSrc: imageURL,
        landscapeImageHandleError,
        portraitImageHandleError,
        portraitImageSrc: mobileLongURL
    } = useGameImageFallback({
        image: imageLandscape,
        longImg: longURL,
        gameCode
    });

    const imgEl = useRef(null);
    const loadImage = (url) => new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => resolve(img));
        img.addEventListener('error', (err) => {
            landscapeImageHandleError();
            portraitImageHandleError();
            reject(err);
        });
        img.src = url;
    });

    useEffect(() => {
        const imgElCurrent = imgEl.current;
        const applyLoadedState = src => {
            loadImage(src)
                .then(() => {
                    isMounted() && setLoadGameImage(true);
                })
                .catch(err => console.warn(err, 'Image is not loaded'));
        };

        if (imgElCurrent && checkImageUrl(isDesktop ? imgElCurrent.src : imgElCurrent.dataset.src)) {
            isDesktop ? applyLoadedState(imgElCurrent.src) : applyLoadedState(imgElCurrent.dataset.src);
        }
    });

    if (isDesktop) {
        return <img
            ref={imgEl}
            alt={alt}
            src={imageURL}
            draggable={draggable}
            className={`${style.image} ${className}`}
            {...props}
        />;
    }

   if (isMobileSpecialCategory === 'long') {
        return (
            <div
                ref={imgEl}
                style={{ backgroundImage: `url('${mobileLongURL}')` }}
                loading="lazy"
                data-src={mobileLongURL}
                draggable={draggable}
                className={`${style.image} ${className}`}
                {...props}
            ></div>
        );
    }
        return (
            <div
                ref={imgEl}
                style={{ backgroundImage: `url('${imageURL}')` }}
                loading="lazy"
                data-src={imageURL}
                draggable={draggable}
                className={`${style.image} ${className}`}
                {...props}
            />
        );
};

export default GameImage;
